export default __webpack_public_path__ + "static/media/wheel-indon.a64c53e1.webp";